module.exports = __webpack_public_path__ + "img/praise.67444196.png";